import { useEffect } from 'react';
import { registerMessageApi } from 'utils/messageUtils';
import { registerNotificationApi } from 'utils/notifications';
import { message, notification } from '@timeedit/ui-components/antd';

export const GlobalMessage = () => {
  const [messageApi, messageContextHolder] = message.useMessage();
  const [notificationApi, notificationContextHolder] =
    notification.useNotification();

  useEffect(() => {
    registerMessageApi(messageApi);
    registerNotificationApi(notificationApi);
  }, [messageApi, notificationApi]);

  return (
    <>
      {messageContextHolder}
      {notificationContextHolder}
    </>
  );
};
